import Button from "components/Button";
import Content from "components/Content";
import Label from "components/Label";
import Media from "components/Media";
import { useRouter } from "next/router";
import React, { FC } from "react";

import styles from "./styles.module.scss";

const GetToKnowVendors: FC = () => {
  const router = useRouter();

  return (
    <Content
      contentClassName={styles.container}
      containerClassName={styles.wrapper}
    >
      <Media at={["desktop"]}>
        <Label className={styles.label} variant="h5" color="primary2">
          Learn more about our vendor network
        </Label>
      </Media>
      <Media at={["mobile", "tablet"]}>
        <Label className={styles.label} variant="h2-centered" color="primary2">
          Learn more about our vendor network
        </Label>
      </Media>
      <Button
        variant="secondary"
        onClick={() => {
          router.push("/vendors");
        }}
      >
        Learn more
      </Button>
    </Content>
  );
};

export default GetToKnowVendors;
